module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "block pagination"
  }, [_c('label', {
    staticClass: "pagin-tip"
  }, [_vm._v("显示第 " + _vm._s(_vm.pTotal === 0 ? 0 : ((_vm.pNum - 1) * _vm.pSize + 1)) + " 条至第 " + _vm._s((_vm.pNum * _vm.pSize) > _vm.pTotal ? _vm.pTotal : (_vm.pNum * _vm.pSize)) + " 条记录")]), _vm._v(" "), _c('el-pagination', {
    attrs: {
      "current-page": _vm.pNum,
      "page-sizes": [5, 10, 20, 50, 100, 150, 200],
      "page-size": _vm.pSize,
      "layout": "total, prev, pager, next, sizes, jumper",
      "total": _vm.pTotal = _vm.totalNum
    },
    on: {
      "size-change": _vm.handlePageSizeChange,
      "current-change": _vm.handlePageCurrentChange
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-55389538"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Pagination.vue
// module id = 710
// module chunks = 1